import { Typography } from '@mui/material';
import { IconButtonWithTooltip, Tooltip } from 'common/components';
import { useCopyToClipboard } from 'common/hooks';
import { CopyIcon } from 'icons';
import type { ApiExceptionMessage } from 'modules/api/utils';

type Props = ApiExceptionMessage & {
  scope: 'stack trace' | 'code';
  onCopySuccess(): void;
  onCopyError(): void;
};

export const ErrorCode = ({ scope, onCopySuccess, onCopyError, ...apiExceptionMessage }: Props) => {
  const { stackTrace, errorId, message } = apiExceptionMessage;

  const { copyToClipboard } = useCopyToClipboard({
    onSuccess: onCopySuccess,
    onError: onCopyError,
  });

  const handleCopyErrorCode = () => {
    copyToClipboard({ text: stackTrace ?? errorId });
  };

  return (
    <>
      <Tooltip title={message}>
        <Typography variant="inherit" component="span" noWrap mr={1}>{`Error code: ${errorId}`}</Typography>
      </Tooltip>

      <IconButtonWithTooltip
        title={`Copy error ${scope}`}
        size="small"
        color="error"
        onClick={handleCopyErrorCode}
        aria-label={`Copy error ${scope}`}
      >
        <CopyIcon fontSize="small" />
      </IconButtonWithTooltip>
    </>
  );
};
